import { EpimsBankDetailDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EpimsBankDetailService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getEpimsBankDetail(id): Observable<EpimsBankDetailDto[]> {
    return this.http.get<EpimsBankDetailDto[]>(
      this.url + 'bank-detail/all/' + id
    );
  }

  createEpimsBankDetail(
    data: EpimsBankDetailDto[]
  ): Observable<EpimsBankDetailDto[]> {
    return this.http.post<EpimsBankDetailDto[]>(this.url + 'bank-detail', data);
  }
  getSingleEpimsBankDetail(id: string): Observable<any> {
    return this.http.get(this.url + 'bank-detail/' + id);
  }

  updateEpimsBankDetail(
    data: EpimsBankDetailDto[]
  ): Observable<EpimsBankDetailDto[]> {
    return this.http.post<EpimsBankDetailDto[]>(
      this.url + 'bank-detail/update',
      data
    );
  }

  deleteEpimsBankDetail(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('bank', ids.join(', '));
    return this.http.delete(this.url + 'bank-detail', httpOptions);
  }
}
